import { TableCell } from '@mui/material'
import React from 'react'
import MySortHeadField from '../../../UI/table/sort/MySortHeadField'
import { useDispatch, useSelector } from 'react-redux'
import { setSupplyBillsSortField, setSupplyBillsSortType } from '../../../../store/supplyBillSlice'
import { getSortMenuList } from '../../../../helpers/sort/SortHelper'

const IdSortField = () => {

    const field = useSelector(state => state.supplyBill.supplyBills.sort.field)
    const type = useSelector(state => state.supplyBill.supplyBills.sort.type)
    const dispatch = useDispatch()

    const menuList = getSortMenuList({
        itemsNeeded: ['reset', 'ASC', 'DESC']
    })

  return (
    <TableCell align="center">
        <MySortHeadField 
            text={'ID'}
            fieldSlug={'id'}
            field={field}
            setField={e => dispatch(setSupplyBillsSortField(e))}
            type={type}
            setType={e => dispatch(setSupplyBillsSortType(e))}
            menuList={menuList}
        />
    </TableCell>
  )
}

export default IdSortField